module.exports = __webpack_public_path__ + "img/pdf.e64290f9.png";